import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from 'src/contexts/authContext'
import { getIncomingAttachmentsPresignedUrl } from 'src/services/requests/tenders/tenders'
import { Spinner } from 'src/components/spinner/Spinner'
import CIcon from '@coreui/icons-react'
import { cilCloudDownload, cilCheckCircle, cilXCircle } from '@coreui/icons'

const IncomingAttachments = () => {
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const auth = useContext(AuthContext)
  const [s3key, setS3Key] = useState();
  const [s3presignedUrl, setS3presignedUrl] = useState('');
  const [errorRaised, setErrorRaised] = useState('');

  const downloadFile = async () => {
    try {
      const response = await fetch(s3presignedUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "attachments.zip";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setErrorRaised(`Error downloading the file: ${error}`);
    }
  };

  useEffect(() => {
    if (errorRaised && errorRaised !== '') {
      console.error(errorRaised);
    }
  }, [errorRaised])

  useEffect(() => {
    const key = location.pathname.split('/');
    if (key.length === 3) {
      setS3Key(key[2])
    } else {
      setErrorRaised(`Cannot extract s3 key from path! Location: ${location}`)
    }
  }, [location])

  useEffect(() => {
    if (s3key) {
      setIsLoading(true)
      getIncomingAttachmentsPresignedUrl(s3key)
        .then(response => {
          if (response.status === 200) {
            setS3presignedUrl(response.data)
          }
        })
        .catch(err => setErrorRaised(err))
        .finally(() => setIsLoading(false))
    }
  }, [s3key])

  useEffect(() => {
    if (s3presignedUrl && s3presignedUrl !== '') {
      downloadFile().then(() => {
        setTimeout(() => {
          navigate('/')
        }, 3000)
      })
    }
  }, [s3presignedUrl])


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}>
      <span><CIcon icon={cilCloudDownload} size="9xl" /></span>
      {isLoading && <span><Spinner/></span>}
      {!isLoading && errorRaised === '' && <div className='spinner--wrapper'><CIcon icon={cilCheckCircle} size="4xl" className="text-success"/></div>}
      {!isLoading && errorRaised !== '' && <div className='spinner--wrapper'><CIcon icon={cilXCircle} size="4xl" className="text-danger"/></div>}
    </div>
  )
}

export default IncomingAttachments
